/**
 * AddressLookUp.ts
 */

const AddressLookUp = (() => {

    let options = {
        initElem: document.getElementsByClassName('js-address-lookup')
    }

    function init() {

        if(options.initElem.length) {

            initLoqate();

            if(EWDS_DEBUG) {
                console.log('[DEBUG] AddressLookUp : initialized');
            }
        }

    }

    function initLoqate() {

        var Loqate = {};

        // REF: https://www.loqate.com/resources/support/setup-guides/advanced-setup-guide/

        var lookUpElem = document.querySelectorAll('[id$="AddressLookUp"]')[0].id;

        Loqate.fields = [
            { element: lookUpElem, field: "", mode: pca.fieldMode.SEARCH}, 
            { element: "Address1", field: "Line1", mode: pca.fieldMode.POPULATE },
            { element: "Address2", field: "Line2", mode: pca.fieldMode.POPULATE },
            { element: "Address3", field: "City", mode: pca.fieldMode.POPULATE },
            { element: "Postcode", field: "PostalCode", mode: pca.fieldMode.POPULATE },
            { element: "PostalCountry", field: "CountryName", mode: pca.fieldMode.COUNTRY },
            { element: "PostalCountryISO", field: "CountryIso2", mode: pca.fieldMode.POPULATE },
            { element: "FormattedAddress", field: "Label", mode: pca.fieldMode.POPULATE }
        ];
    
        Loqate.options = { 
            key: "NM99-CE84-KJ25-DY75", 
            setCountryByIP: false,
            suppressAutocomplete: false
        };
    
        Loqate.control = new pca.Address(Loqate.fields, Loqate.options);
        
        Loqate.control.listen("populate", function(address, variations) {               
                        
            document.getElementsByName(lookUpElem)[0].value = '';

        });
    }

    return {
        init: init
    };

})();

export default AddressLookUp;